module.exports = __webpack_public_path__ + "img/clock.6a119980.svg";